import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../components/contexts/UserContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { PrismicRichText } from '@prismicio/react';
import LoadingNew from '../components/utils/LoadingNew';
import axios from 'axios';
import apiEndpoint from '../utils/apiEndpoint';
import { useTranslation } from 'react-i18next';
import { TermsContext } from '../components/contexts/TermsContext';
import { isBefore } from 'date-fns';

const TermsAndConditions = ({ termsProductType, termsDocumentType, online }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('maastotaulukot');

  const [isLoading, setIsLoading] = useState(true);

  // Get the route the user tried to visit
  const fromRoute = location.state?.from?.pathname || '/';

  const [userState, setUserState] = useContext(UserContext);
  const [termDocs] = useContext(TermsContext);

  const currentTermDoc = termDocs.find((doc) => doc.type === termsDocumentType);
  const acceptedTerms = userState?.terms_accepted
    ? userState.terms_accepted.find(
        (acceptedTerm) => acceptedTerm.product_name === termsProductType
      )
    : undefined;

  const acceptTerms = () => {
    axios
      .post(`${apiEndpoint}/api/terms/accept/`, { product_name: termsProductType })
      .then((response) => {
        if (response.status === 201) {
          const newUserData = {
            ...userState,
            terms_accepted: acceptedTerms
              ? userState.terms_accepted.map((term) =>
                  term.product_name === response.data.terms.product_name
                    ? { ...term, accepted_at: response.data.terms.accepted_at }
                    : term
                )
              : [{ ...response.data.terms }],
          };
          setUserState(newUserData);

          window.localStorage.setItem('user', JSON.stringify(newUserData));

          navigate(fromRoute, { replace: true });
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  useEffect(() => {
    document.title = `Käyttöehdot - TAPIO Maastotaulukot`;
  }, []);

  useEffect(() => {
    if (currentTermDoc && online) {
      if (
        acceptedTerms &&
        isBefore(
          new Date(currentTermDoc.last_publication_date),
          new Date(acceptedTerms.accepted_at)
        )
      ) {
        navigate(fromRoute, { replace: true });
      }

      setIsLoading(false);
    }

    if (!online) {
      navigate('/', { replace: true });
    }
  }, [acceptedTerms, currentTermDoc, navigate, fromRoute, online]);

  if (isLoading) {
    return <LoadingNew />;
  }

  return (
    <div className="page" style={{ paddingBottom: 160 }}>
      <div className="page-title">
        <PrismicRichText field={currentTermDoc?.data?.title} />
      </div>
      <div className={'slices-container'}>
        <PrismicRichText field={currentTermDoc?.data?.content} />
      </div>

      <div className={'slices-container'} style={{ paddingTop: 40 }}>
        <button className="button default" onClick={acceptTerms}>
          {t('terms_and_conditions.accept')}
        </button>
      </div>
    </div>
  );
};

export default TermsAndConditions;
